import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS } from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../components/private/pagination";

const Contrato = () => {

  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(true);

  // FILTROS
  const [filter, setFilter] = useState({
    searchQuery: "",
    estado: "",
    fechaInicio: "",
    fechaFin: "",
    entidad: ""
  });

  // PAGINACIÓN
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =======================
  // CARGAR DATOS
  // =======================
  useEffect(() => {

    if (!token) return;

    const loadContratos = async () => {
      setLoading(true);

      const res = await authFetch(ENDPOINTS.getContratoProyecto);

      if (res.success) setContratos(res.data);
      else setContratos([]);

      setLoading(false);
    };

    loadContratos();

  }, [token, authFetch]);

  // =======================
  // MANEJO FILTROS
  // =======================
  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  // =======================
  // FORMATO FECHA
  // =======================
    const formatDate = (dateString) => {
    if (!dateString) return "---";

    const [year, month, day] = dateString.split("-");

    return `${day}/${month}/${year}`;
    };
  // =======================
  // FILTRO
  // =======================
  const handleSearch = () => {

    const query = filter.searchQuery.toLowerCase();

    return contratos.filter((item) => {

      const contrato = (item.num_contrato || "").toLowerCase();
      const entidad = (item.entidad || "").toLowerCase();

      const matchSearch =
        contrato.includes(query) ||
        entidad.includes(query);

      const matchEstado =
        !filter.state || Number(item.state) === Number(filter.state);

      const matchEntidad =
        !filter.entidad || item.id_entidad === Number(filter.entidad);

      const matchFechaInicio =
        !filter.fechaInicio || item.start_date >= filter.fechaInicio;

      const matchFechaFin =
        !filter.fechaFin || item.end_date <= filter.fechaFin;

      return (
        matchSearch &&
        matchEstado &&
        matchEntidad &&
        matchFechaInicio &&
        matchFechaFin
      );
    });
  };

  const filtered = handleSearch();

  // =======================
  // PAGINACIÓN
  // =======================
  const totalPages = Math.ceil(filtered.length / recordsPerPage);

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;

  const currentRecords = filtered.slice(indexOfFirst, indexOfLast);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // =======================
  // VER PDF
  // =======================
  const handleViewPDF = (doc) => {
    if (!doc) return alert("No hay documento");

    window.open(`${API_BASE_URL_DOCS}${doc}`, "_blank");
  };

  if (loading) return <p>Cargando contratos...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Contratos</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/mod_proyectos/contrato_proyectos/createContrato")}
        >
          <i className="bi bi-plus-lg me-1"></i> Crear Contrato
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">

        <div className="col-md-4">
          <label>Buscar por entidad</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-2">
          <label>Estado</label>
          <select
            name="state"
            className="form-select"
            value={filter.state}
            onChange={handleFilterChange}
          >
            <option value="">Todos</option>
            <option value="1">Activo</option>
            <option value="0">Inactivo</option>
          </select>
        </div>

        <div className="col-md-3">
          <label>Fecha inicio</label>
          <input
            type="date"
            name="fechaInicio"
            className="form-control"
            value={filter.fechaInicio}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-3">
          <label>Fecha fin</label>
          <input
            type="date"
            name="fechaFin"
            className="form-control"
            value={filter.fechaFin}
            onChange={handleFilterChange}
          />
        </div>

      </div>

      {/* TABLA */}
      {currentRecords.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th># Contrato</th>
                <th>Entidad</th>
                <th>Objeto</th>
                <th>Valor</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentRecords.map((c) => (
                <tr key={c.id_contrato}>
                  <td>{c.num_contrato}</td>
                  <td>{c.entidad}</td>
                  <td>{c.objeto}</td>
                  <td>${c.valor_contrato}</td>
                  <td>{formatDate(c.start_date)}</td>
                  <td>{formatDate(c.end_date)}</td>
                  <td>
                    {Number(c.state) === 1 ? "Activo" : "Inactivo"}
                  </td>

                  <td>
                      <div className="d-flex gap-2">
                        <button
                        className="btn btn-outline-purple btn-sm"
                        onClick={() => handleViewPDF(c.doc_contra_partida)}
                        >
                            <i className="bi bi-eye-fill me-1 m-2"></i> Ver PDF
                        </button>

                        <button
                        className="btn btn-secondary btn-sm d-inline-flex align-items-center me-1"
                        onClick={() =>
                        navigate(`/session/mod_proyectos/contrato_proyectos/updateContrato/${c.id_contrato}`)}>
                            <i className="bi bi-pencil-square me-1"></i>
                            <span>Modificar</span>
                        </button>


                      </div>
             
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay contratos registrados.</p>
      )}

    </div>
  );
};

export default Contrato;